import {useCallback} from 'react';

import {KYC_APPROVED_EVENTS} from '@/app/auth/events/KycApprovedEvents';
import {PROJECT_TAGS} from '@/constants';
import {useTrackingManager} from '@/hooks';

export interface IAdIdsTrack {
  provider?: string;
  id?: string;
}

export interface TrackViewKycApprovedProps {
  adIds?: IAdIdsTrack;
  userCohort?: string;
}

export const useTrackers = () => {
  const {trackEvent} = useTrackingManager();

  const trackViewKycApproved = useCallback(
    (props: TrackViewKycApprovedProps) => {
      trackEvent(KYC_APPROVED_EVENTS.VIEW_KYC_APPROVED, {
        project_tag: PROJECT_TAGS.ONBOARDING,
        metadata: {
          AD_CLICK_IDS_V1: {
            ...props?.adIds,
          },
          USER_COHORT: props?.userCohort,
        },
      });
    },
    [trackEvent],
  );

  return {
    trackViewKycApproved,
  };
};
